import { portalApiClient } from '@/utilities/api'
import type { AddressSuggestionSchemaType } from '@/types/portal-api.generated'
import type { AxiosRequestConfig } from 'axios'

export const getAddressSuggestions = async (
  query: string,
  axiosConfig: Pick<AxiosRequestConfig, 'signal'> = {},
): Promise<AddressSuggestionSchemaType[]> => {
  const response = await portalApiClient.autocomplete_address_v3_address_post(
    {
      query,
      country: 'USA',
    },
    axiosConfig,
  )
  return response.suggestions
}
